import { User } from '@recruitee/http-types';

export enum EntityStoreKey {
  candidate = 'candidate',
}

export const enum CandidateErrorCode {
  CannotAssignAdminWithoutAccess = 'cannot_assign_admin_without_access',
}

/**
 * Each policy defines which users will be permitted or denied access to a candidate.
 */
export enum AccessToCandidatePolicy {
  /**
   * Users grouped based on a candidate's hiring status,
   * the user's ability to view hired candidates, its role abilities (ViewCandidates, ViewAllJobs)
   * and whether the user has direct access to a candidate or has had been shared the candidate with.
   */
  Common = 'common',
  /**
   * Similar to common, but if candidate context is available the access to
   * a placement will be taken into account or, if not available, access to an offer.
   */
  Offer = 'offer',
  /**
   * Groups users based on whether they have the ability to view any candidate or not.
   * This will usually lead to the broadest set of users with access.
   */
  NoCandidateViewAbility = 'no_candidate_view_ability',
}

export interface AtcGroupedUsers {
  usersWithAccess: User[];
  usersWithoutAccess: User[];
}
